import React from 'react';
import ReservationForm from '../../Reservations/ReservationForm/ReservationForm';
import './HomeContact.css';

const HomeContact = () => {
    return (
        <>
            <div className="row gx-0 d-flex justify-content-center align-items-center home-contact-image position-relative">
                <div className="col-12 col-md-8 " style={{ backgroundColor: "transparent", color: "#fff" }}>
                {/* <div className='reservation-banner-background-overlay'></div> */}
                    {/* <div className="reservation-banner-background-overlay"></div> */}
                    <ReservationForm />
                </div>
                <div className="col-12 col-md-4 d-flex flex-column justify-content-center align-items-center text-white py-3 py-md-5">
                    <div className="row gx-0 d-flex justify-content-center align-items-center">
                        <div className="col-11 col-md-10 d-flex flex-column px-3 py-3 px-md-3 py-md-5" style={{ backgroundColor: "#021d2a" }}>
                            <div className="row gx-0" style={{ borderBottom: "1px dotted #F7EA80" }}>
                                <div className="col-12 text-center py-3 py-md-5">
                                    <h3>Nous Contacter</h3>
                                    <h5>Demande De Réservation</h5>
                                    <h4 style={{ color: "#F7EA80" }}>05 67 48 47 33</h4>
                                    <h5>Emplacement</h5>
                                    <address>LE SONARGA Restaurant & Gastronomie, 124 Rue Jean Adoué 31800 Saint-Gaudens, France</address>
                                </div>
                            </div>
                            <div className="row gx-0 gy-3 gy-md-0 py-5 d-flex flex-column flex-md-row justify-content-between align-items-center">
                                <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center align-items-md-start">
                                    <h5>L'heure Du Déjeuner</h5>
                                    <p>Monday to Sunday</p>
                                    <p>10.30 am to 3.00 pm</p>
                                </div>
                                <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center align-items-md-start">
                                    <h5>L'heure Du Dîner</h5>
                                    <p>Monday to Sunday</p>
                                    <p>5.30 am to 11.00 pm</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomeContact;